// Simple Google Analytics utility functions
// No cookies, no consent needed - just basic tracking

// Track page views
export const trackPageView = (pageName = "home") => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "page_view", {
      page_title: pageName,
      page_location: window.location.href,
    });
    console.log(`Analytics: Page view tracked - ${pageName}`);
  }
};

// Track link clicks
export const trackLinkClick = (linkName, linkUrl = "") => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "click", {
      event_category: "external_link",
      event_label: linkName,
      link_url: linkUrl,
    });
    console.log(`Analytics: Link click tracked - ${linkName}`);
  }
};

// Track custom events
export const trackEvent = (eventName, eventData = {}) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", eventName, {
      event_category: "engagement",
      ...eventData,
    });
    console.log(`Analytics: Event tracked - ${eventName}`);
  }
};
